<main class="container" style="min-height: 73vh">
  <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout39">      
      <div class="row">
        <div class="col col-12">
          <library-selector></library-selector>
        </div>
    </div>
  </section>
  <section id="column2">
      <div class="row">
        <div class="col col-12">
          <library-table></library-table>
        </div>
      </div>
  </section>
</main>


